import { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIList from 'UIComponents/list/UIList';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { TeamOptionType } from '../types/OptionTypes';
import { getSortedFlattenedTeamsList } from '../utils/TeamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IndentedTeamOption = styled.div.withConfig({
  displayName: "SelectableTeamsList__IndentedTeamOption",
  componentId: "v82o66-0"
})(["padding-left:", ";"], props => `${props.depth * 10}px`);
const TeamCheckbox = ({
  id,
  name,
  depth,
  checked,
  onRemoveTeam,
  onAddTeam,
  disabled
}) => {
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    _jsx(IndentedTeamOption, {
      depth: depth,
      children: /*#__PURE__*/_jsx(UICheckbox, {
        value: id,
        checked: checked,
        className: "p-y-1",
        disabled: disabled,
        "data-test-id": "team-checkbox",
        onChange: () => {
          if (checked) {
            onRemoveTeam(id);
          } else {
            onAddTeam(id);
          }
        },
        children: /*#__PURE__*/_jsxs("span", {
          "data-test-id": `assign-team-checkbox-${id}`,
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "lists",
            className: "m-right-2"
          }), name]
        })
      })
    })
  );
};
class SelectableTeamsList extends Component {
  constructor(...args) {
    super(...args);
    this.renderTeamCheckbox = ({
      depth,
      id,
      name
    }) => {
      const {
        selectedTeamIds = [],
        onAddTeam,
        onRemoveTeam,
        rootLevelTeamIds,
        userHasTeamAssignmentScope,
        allowedTeamIds,
        DisallowedTeamFormattedMessage
      } = this.props;
      const checked = selectedTeamIds.includes(id);
      const isRootLevelTeam = rootLevelTeamIds.includes(id);
      const isDisabled = isRootLevelTeam && checked && !userHasTeamAssignmentScope;
      const isTeamDisallowed = allowedTeamIds && !allowedTeamIds.includes(id);
      const key = `${id}-team-checkbox`;
      const checkbox = /*#__PURE__*/_jsx(TeamCheckbox, {
        id: id,
        name: name,
        depth: depth,
        checked: checked,
        disabled: isDisabled || isTeamDisallowed,
        onAddTeam: onAddTeam,
        onRemoveTeam: onRemoveTeam
      }, key);
      if (isDisabled || isTeamDisallowed) {
        return /*#__PURE__*/_jsx(UITooltip, {
          placement: "left",
          title: isTeamDisallowed ? /*#__PURE__*/_jsx(DisallowedTeamFormattedMessage, {
            teamId: id,
            teamName: name
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'ui-asset-management-lib.tooltips.disabledTeamTooltip'
          }),
          children: /*#__PURE__*/_jsx("span", {
            children: checkbox
          })
        }, key);
      }
      return checkbox;
    };
  }
  render() {
    const {
      teams
    } = this.props;
    const teamOptions = getSortedFlattenedTeamsList(teams);
    return /*#__PURE__*/_jsx(UIList, {
      children: teamOptions.map(team => this.renderTeamCheckbox({
        depth: team.depth || 0,
        id: team.id,
        name: team.name
      }))
    });
  }
}
SelectableTeamsList.propTypes = {
  teams: PropTypes.arrayOf(TeamOptionType).isRequired,
  selectedTeamIds: PropTypes.arrayOf(PropTypes.number),
  onAddTeam: PropTypes.func.isRequired,
  onRemoveTeam: PropTypes.func.isRequired,
  rootLevelTeamIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  userHasTeamAssignmentScope: PropTypes.bool.isRequired,
  allowedTeamIds: PropTypes.arrayOf(PropTypes.number),
  DisallowedTeamFormattedMessage: PropTypes.func
};
export default SelectableTeamsList;